/*
 * Title: 회원초대 서비스
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 * @Object: GentleServiceInviteMember
 * @Property Value
 * - sponserId: 후원인 아이디
 * - sponserName: 후원인 이름
 * @Property Method
 * - selectInviteType: 회원초대방식선택
 * - sponserIsMe: 나를 후원인으로 초대장 생성
 * - sponserIsOther: 다른 사람을 후원인으로 초대장 생성
 */

import GentleWidget from "../common/widget";
import GentleLang from "../common/lang";
import GentleAppState from "../common/appstate";
import GentleComponentButton from "../component/button";
import GentleComponentBubble from "../component/bubble";
import GentleUtil from "../common/util";
import language from "../lang";
import GentleProxy from "../common/proxy";
import GentleServiceConsulting from "./consulting";

var GentleServiceCallCenter = Object.create(GentleWidget, {
  sponserId: { writable: true, configurable: false, enumerable: true },
  sponserName: { writable: true, configurable: false, enumerable: true },
});

/*
2025.2 - 회원정보 요청
"example": {
  "request": {
    "method": "POST",
    "url": "https://oadev.atomyn.com/ssoTokenCheck",
    "headers": {
      "user-token": "{user-token}"  // 로그인으로 발급받은 사용자 토큰
    }
  },
  "response": {
    "result": "200",  // 응답 코드 (성공)
    "resultMessage": "SUCCESS",  // 응답 메시지
    "siteNo": "KR",  // 요청한 사이트 번호
    "locale": "ko_KR",  // 요청한 사이트 언어 및 번호
    "time": "2025-02-13T09:52:14.685386400+09:00[Asia/Seoul]",  // 응답 시간
    "item": {
      "message": "Valid SSO Token",  // 인증 메시지
      "customer": {  // 회원 정보
        "id": "40998424",  // 회원번호
        "name": "test",  // 회원명
        "email": "sadf@outlook.co.sg",  // 이메일
        "cellphone": "87653452",  // 휴대폰번호
        "maxCode": "01",  // 명목 직급 코드
        "maxName": "판매원",  // 명목 직급명 (한글)
        "levelCode": "01",  // 현재 직급 코드
        "levelName": "판매원",  // 현재 직급명 (한글)
        "createDate": "20240903000000",  // 회원 생성일자
        "companyCode": "06",  // 지사 코드
        "companyName": "싱가포르",  // 지사명 (한글)
        "centerCode": "007",  // 센터 코드
        "centerName": "LC@ A+ YISHUN111",  // 센터명
        "customerNationality": "08",  // 회원 국가 코드
        "signupNationalityCode": "6",  // 회원 가입 국적 코드
        "smsAgreed": "0",  // SMS 수신 동의 여부
        "emailAgreed": "1"  // 이메일 수신 동의 여부
      }
    }
  }
}

*/
GentleServiceCallCenter.chat = function (json) {
  console.log("GentleServiceCallCenter.chat");
  const component = Object.create(this);

  // api
  const request = function () {
    const onSuccess = function (data) {
      console.log("onSuccess>", data);
      switch (data.Status) {
        case 1:
          const { Data } = data;
          console.log("Data>", Data);

          render(Data);
          break;
        default:
          break;
      }
    };

    const onFailed = function (data) {
      console.log("onFailed");
    };

    const proxy = Object.create(GentleProxy);
    proxy.request("userinfo", {}, onSuccess, onFailed);
  };

  const render = function (data) {
    console.log("render", data);
    // const { CustNo, CustName, Email, HandPhone } = data;
    const { CustNo } = data;
    console.log(CustNo);
    let history = JSON.stringify(window.chatbotHistory);
    console.log(history);

    // todo : 상담히스토리
    const html = `
        <div>
            <form name="form-chat" action="https://atomy.enomix.co.kr/sharedfront/jsp/view/chatWindow.jsp" method="post" target='_blank' >
                <input type="hidden" name="CustNo" value="${CustNo}" />
                <textarea id="history" style="display:none" name="history" rows="1" cols="33">${history}</textarea>             
            </form>
        </div>
        `;
    // const html = `
    // <div>
    //     <form name="form-chat" action="https://atomy.enomix.co.kr/sharedfront/jsp/view/chatWindow.jsp" method="post" target='_blank' >
    //         <input type="hidden" name="CustNo" value="${CustNo}" />
    //         <input type="hidden" name="history" value="${history}" />
    //         <textarea id="story" name="story" rows="5" cols="33">
    //         ${history}
    //         </textarea>
    //     </form>
    // </div>
    // `;
    const $card = $(html);

    component.setPrefix("chat");
    component.init($card);
    component.insert();

    // bubble
    {
      const html = GentleLang.translateService(
        language.callCenter,
        language.callCenter.type.Info
      );
      var bubble = Object.create(GentleComponentBubble);
      bubble.createComponent({
        html,
      });
      bubble.insert();
    }

    // button
    {
      const text = "채팅상담으로 상담하기"; //GentleLang.translate(GentleLang.type.AtomyNewProduct);
      const option = [
        {
          text: text,
          user: "user",
          send: false,
          isHidden: true,
          onClick: function () {
            const target = window.open(
              "",
              "chatWindow",
              "toolbar=no, width=450, height=650"
            );
            var $form = component.find('[name="form-chat"]')[0];
            // console.log('form', $form);
            $form.target = "chatWindow";
            $form.submit();
          },
        },
      ];
      var button = Object.create(GentleComponentButton);
      button.createComponent(option);
      button.insert();
    }

    GentleUtil.timeStamp();
  };

  if (GentleAppState.isLogin) {
    request();
  } else {
    render({ CustNo: "" });
  }
};

GentleServiceCallCenter.info = function (json) {
  const html = GentleLang.translateService(
    language.callCenter,
    language.callCenter.type.Info
  );
  var bubble = Object.create(GentleComponentBubble);
  bubble.createComponent({
    html,
  });
  bubble.insert();

  {
    const text = "채팅상담으로 상담하기"; //GentleLang.translate(GentleLang.type.AtomyNewProduct);
    const option = [
      {
        text: text,
        user: "user",
        send: false,
        isHidden: true,
        onClick: function () {
          GentleServiceConsulting.TalkAvailable();
        },
      },
    ];
    var button = Object.create(GentleComponentButton);
    button.createComponent(option);
    button.insert();
  }
};
GentleServiceCallCenter.disabledAPI = function (json) {
  const html = GentleLang.translate(GentleLang.type.UpdateDisable);
  var bubble = Object.create(GentleComponentBubble);
  bubble.createComponent({
    html,
  });
  bubble.insert();

  {
    const text = "채팅상담으로 상담하기"; //GentleLang.translate(GentleLang.type.AtomyNewProduct);
    const option = [
      {
        text: text,
        user: "user",
        send: false,
        isHidden: true,
        onClick: function () {
          GentleServiceConsulting.TalkAvailable();
        },
      },
    ];
    var button = Object.create(GentleComponentButton);
    button.createComponent(option);
    button.insert();
  }
};
GentleServiceCallCenter.main = function (json) {
  const component = Object.create(this);

  const render = function (data) {
    console.log("render");

    // 봇버블
    {
      const html = GentleLang.translateService(
        language.callCenter,
        language.callCenter.type.Bot
      );
      var bubble = Object.create(GentleComponentBubble);
      bubble.createComponent({
        html,
      });
      bubble.insert();
    }

    // button
    {
      const text = GentleLang.translateService(
        language.callCenter,
        language.callCenter.type.Kakao
      );
      const option = [
        {
          isHidden: true,
          send: false,
          text: text,
          onClick: function () {
            GentleAppState.isPc
              ? window.open(language.url.pc.KakaoChatLink)
              : window.open(language.url.mobile.KakaoChatLink);

            // // temp code
            // {
            //     // 상담요청
            //     GentleServiceConsulting.TalkAvailable();
            // }
          },
        },
      ];
      var button = Object.create(GentleComponentButton);
      button.createComponent(option);
      button.insert();
    }
    GentleUtil.timeStamp();
  };

  render();
};

export default GentleServiceCallCenter;
